import { Conversation } from 'src/graphql';

export enum SuggestionBucket {
  SameRequester = 'sameRequester',
  CurrentlyOpened = 'currentlyOpened',
}

export enum MergeSuggestionsStatus {
  Loading = 'loading',
  Ready = 'ready',
  Empty = 'empty',
  Error = 'error',
}

export interface MergeTargetSuggestion {
  conversation: Conversation;
  bucket: SuggestionBucket;
  friendlyId: string;
  subject: string;
  date: string;
  requesterName?: string;
  statusId: string;
}

export interface MergeSuggestionGroup {
  bucket: SuggestionBucket;
  label: string;
  rows: MergeTargetSuggestion[];
}

export interface MergeSuggestionsState {
  status: MergeSuggestionsStatus;
  groups: MergeSuggestionGroup[];
}
